var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLock = function SvgLock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1 0h12v12H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.588 12c-.26 0-.47-.226-.47-.504v-6.05c0-.279.21-.505.47-.505h7.53c.26 0 .47.226.47.504v6.05c0 .28-.21.505-.47.505h-7.53 0z",
    stroke: "#CCC",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.176 4.941V3.446c0-1.513-1.263-2.74-2.823-2.74s-2.824 1.227-2.824 2.74v1.495",
    stroke: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.059 8.4c0-.35-.316-.635-.706-.635-.39 0-.706.284-.706.635 0 .187.092.354.235.47v.589c0 .234.211.423.47.423.26 0 .472-.19.472-.423V8.87a.607.607 0 00.235-.471z",
    fill: "#FFF"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock.70edc82f.svg";
export { ForwardRef as ReactComponent };